/**
 * Gets dimensions of images uploaded via Element UI
 * @param {File|Blob|string} file - File object, Blob, or URL from Element upload
 * @returns {Promise<{width: number, height: number}>}
 */
export default function getElementImageSize(file) {
  return new Promise((resolve, reject) => {
    const handleImageLoad = (url) => {
      const img = new Image();
      img.onload = function() {
        resolve({ width: img.width, height: img.height });
      };
      img.onerror = function() {
        reject(new Error('Failed to load image'));
      };
      img.src = url;
    };

    if (!file) {
      reject(new Error('No file provided'));
      return;
    }

    // Handle File/Blob objects from Element upload
    if (file instanceof File || file instanceof Blob) {
      const reader = new FileReader();
      reader.onload = (e) => handleImageLoad(e.target.result);
      reader.onerror = () => reject(new Error('File reading failed'));
      reader.readAsDataURL(file);
    } 
    // Handle Blob URLs
    else if (typeof file === 'string' && file.startsWith('blob:')) {
      handleImageLoad(file);
    }
    // Handle regular URLs
    else if (typeof file === 'string') {
      handleImageLoad(file);
    }
    // Unsupported type
    else {
      reject(new Error('Unsupported file type'));
    }
  });
}
